// extracted by mini-css-extract-plugin
export default {"companies":"UserProfileDropdown_companies__U8ac8"};